import { useEffect } from 'react';
import { useRouter } from 'next/router';

// useScrollRestoration.ts
const useScrollRestoration = () => {
    const router = useRouter();
    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
            const saveScrollPosition = (url) => {
                sessionStorage.setItem(`scrollPosition:${url}`, JSON.stringify({ x: window.scrollX, y: window.scrollY }));
            };
            const onBeforeUnload = (event) => {
                saveScrollPosition(router.asPath);
                const e = event; // Use a local variable to handle the reassignment
                delete e.returnValue;
            };
            const onRouteChangeStart = () => {
                saveScrollPosition(router.asPath);
            };
            const onRouteChangeComplete = (url) => {
            };
            router.events.on('routeChangeStart', onRouteChangeStart);
            router.events.on('routeChangeComplete', onRouteChangeComplete);
            window.addEventListener('beforeunload', onBeforeUnload);
            return () => {
                router.events.off('routeChangeStart', onRouteChangeStart);
                router.events.off('routeChangeComplete', onRouteChangeComplete);
                window.removeEventListener('beforeunload', onBeforeUnload);
                window.history.scrollRestoration = 'auto';
            };
        }
        // Return a no-op cleanup function if scrollRestoration is not supported
        return () => { };
    }, [router]);
};

export { useScrollRestoration as default };
//# sourceMappingURL=useScrollRestoration.js.map
